module.exports = __webpack_public_path__ + "static/img/OrganizationC250107EN.876bb30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OrganizationC250107EN.jpg
// module id = M3tv
// module chunks = 1